export const contactFormScroll = () => {
  if (document.body.classList.contains("page-detail")) {
    const contactLink = document.querySelectorAll(".widget-contacto-link");
    const contactForm = document.querySelector(".widget-contacto");

    contactLink.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        console.log("click");
        contactForm.scrollIntoView({ behavior: "smooth" });
      });
    });
  }
};
